import React, { useEffect, useRef, useState } from 'react';
import './transaction-view.styles.scss';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';
import { format } from 'date-fns';
import ImageContainer from '../image-container/image-container.component';
import TransactionItemCard from './transaction-item-card.component';
import HiddenText from '../hidden-text/hidden-text.component';
import { stripHtml } from '@/utils/sanitize';
import { useSelector } from 'react-redux';
import { properCase } from '@/utils/properCase';
import { ModalAlert } from '@/components/modal/modal.component';

const TransactionView = ({
  gameElements,
  activityToDisplay,
  playerList,
  gameManagers,
  hidePlayer,
  hideBackButton
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [transactionData, setTransactionData] = useState(null);
  const [ elementData, setElementData ] = useState(null);
  const [player, setPlayer] = useState(null);
  const [transLogs, setTransLogs] = useState(null);
  const [ alertMessage, setAlertMessage ] = useState(null);
  const { transPath, elementPath } = useParams();
  const navigate = useNavigate();
  const approveRef = useRef(null);

  useEffect(() => {
    if (!transPath || !playerList) return
    if (Object.keys(activityToDisplay).length === 0) return
    const transData = Object.values(activityToDisplay).find(a => a.path === transPath);
    if (!transData) {
      navigate(-1);
      return;
    }
    console.log(transData);
    setTransactionData(transData);
    console.log(playerList[transData.playerId]);
    setPlayer(playerList[transData.playerId] ?? null);
    if (transData.type.toLowerCase().includes('checkpoint')) {
      const checkPointData = gameElements[transData.questId].checkpoints
        .find(c => c.id === transData.elementId);
      if (!checkPointData) {
        setAlertMessage('Checkpoint data not found.');
        approveRef.current = () => navigate(-1);
      }
      checkPointData.questName = gameElements[transData.questId].name;
      setElementData(checkPointData); 
    } else if (transData.elementId) {
      let el = gameElements[transData.elementId];
      if (!el) {
        el = transData
      }
      setElementData(el);
    } else {
      setElementData(Object.values(gameElements).find(e => e.path === elementPath));
    }
  }, [transPath, playerList, activityToDisplay])

  useEffect(() => {
    if (transactionData?.activity === 'Bulk Distribution') {
      formatTransLogs();
    }
  }, [transactionData])

  function formatTransLogs() {
    // console.log('formatting logs')
    if (!transactionData || !transactionData.data || !transactionData.data.logs) return;
    // get player Ids
    const formattedLogs = {}
    transactionData.data.logs
      .map(log => {
        if (formattedLogs[log.playerId]) {
          formattedLogs[log.playerId].logs.push(log);
        } else {
          formattedLogs[log.playerId] = {
            'playerId': log.playerId,
            'playerName': log.playerName,
            'logs': [log]
          };
        }
      });
    // console.log(formattedLogs);
    setTransLogs(formattedLogs);
  }

  return (
    <div className={`transaction-view ${screenSize}`}>
      {
        (!hideBackButton) &&
        <BackButton cancel={() => navigate(-1)} />
      }
      <div className="g-space-1"></div>

      {
        (transactionData && player)
          ?
          <div className='transaction-data'>
            <div className='header'>
              <div className='left'>
                {
                  (transactionData.type === 'purchase')
                    ?
                    <div className='title'>
                      <ImageContainer src={transactionData.icon} />
                      <div className='title-info'>
                        <h4>{
                          transactionData.appId
                          ? 'Point of Sale Purchase'
                          : 'Player Store Purchase'
                        }</h4>
                      </div>
                    </div>
                    :
                    (transactionData.type === 'rewards' && transactionData.display === 'prizepack')
                      ?
                      <div className='title'>
                        <ImageContainer src={transactionData.icon} />
                        <div className='title-info'>
                          <h4>New Prize Pack</h4>
                          <div className="meta">
                            {format(new Date(transactionData.ts), "Pp")}
                          </div>
                        </div>
                      </div>
                    :
                    (transactionData.type === 'rewards')
                      ?
                      <div className='title'>
                        <ImageContainer src='/images/icons/treasure.png' />
                        {
                          (transactionData.title) &&
                          <h4>{transactionData.title}</h4>
                        }
                        <div className='title-info'>
                          <h4>Rewards Earned</h4>
                          <div className="meta">
                            {format(new Date(transactionData.ts), "Pp")}
                          </div>
                        </div>
                        
                      </div>
                      :
                      (transactionData.type === 'collections')
                      ?
                      <div className='title'>
                        <ImageContainer src={transactionData.icon} />
                        <div className='title-info'>
                          <h4>Collection Completed</h4>
                          <div className="meta">
                            {format(new Date(transactionData.ts), "Pp")}
                          </div>
                        </div>
                      </div>
                      :
                      (transactionData.type === 'approvedChallenge' || transactionData.type === 'approvedCheckpoint')
                        ?
                        <div className='title'>
                          <ImageContainer src={transactionData.icon} />
                          {/* <h3>Challenge Approved<br />{gameElements[transactionData.elementId].name}</h3> */}
                          <div className='title-info'>
                            <h4>{
                              transactionData.type === 'approvedChallenge' 
                              ? 'Challenge Approved'
                              : transactionData.type === 'approvedCheckpoint' 
                              ? 'Checkpoint Approved'
                              : 'Unknown Activity'
                            }</h4>
                            <h3>{elementData?.name}</h3>
                            {
                              (elementData?.desc) &&
                              <p className='meta'>{
                                elementData?.desc &&
                                stripHtml(elementData?.desc).substring(0, 80)
                              }
                                {
                                  elementData?.desc &&
                                    stripHtml(elementData?.desc).length > 80 ?
                                    '...' :
                                    ''
                                }</p>
                            }
                            {
                              (elementData?.questName) &&
                              <h5>From Quest: {elementData?.questName}</h5>
                            }
                          </div>
                        </div>
                        :
                        (transactionData.type === 'levels')
                          ?
                          <div className='title'>
                            <ImageContainer src={transactionData.icon} />
                            <div className='title-info'>
                              <h3>Level Earned<br />{gameElements[transactionData.elementId].name}</h3>
                            </div>
                          </div>
                          :
                          (transactionData.type === 'approvedItem')
                            ?
                            <div className='title'>
                              <ImageContainer src={transactionData.icon} />
                              <div className='title-info'>
                                <h3>Item Approved<br />{gameElements[transactionData.elementId].name}</h3>
                              </div>
                            </div>
                            :
                            (transactionData.type === 'secretCode')
                              ?
                              <div className='title'>
                                <ImageContainer src={transactionData.icon} />
                                <div className='title-info'>
                                  <h3>Secret Code Found</h3>
                                  <h3>{<HiddenText text={transactionData.title} hidden={true} />}</h3>
                                  {
                                    (transactionData.info) &&
                                    <p>{transactionData.info}</p>
                                  }
                                </div>
                              </div>
                              :
                              (transactionData.type === 'lootKey')
                              ?
                              <div className='title'>
                                <ImageContainer src={transactionData.icon} />
                                <div className='title-info'>
                                  <h3>Loot Key Redeemed</h3>
                                  <h4>{transactionData.title}</h4>
                                  {
                                    (elementData.desc) &&
                                    <p>{elementData.desc}</p>
                                  }
                                </div>
                              </div>
                              :
                              (transactionData.type === 'momentum')
                    ?
                    <div className='title'>
                      <ImageContainer src={transactionData.icon} />
                      <div className='title-info'>
                        <h3>Momentum Card</h3>
                        <h4>"{transactionData.title}"</h4>
                        <p className={`meta ${transactionData.spec}`}>{properCase(transactionData.spec)}</p>
                      </div>
                    </div>
                    : ''
                }
                {
                  (
                    transactionData &&
                    gameManagers?.length > 1
                  ) &&
                  <div className='meta'>
                    <div className="g-space-0-5"></div>
                    Manager: {
                      gameManagers.find(m => m.appId === transactionData.appId)?.fName
                    } {
                      gameManagers.find(m => m.appId === transactionData.appId)?.lName
                    }
                  </div>
                }
              </div>
              {
                (!hidePlayer) &&
                <div className='player-info'>
                  <div className='player-name'>
                    {`${player.fName}${player.lName ? ` ${player.lName}` : ''}`}
                  </div>
                  <UserIcon profile={player} small={true} />
                </div>
              }
            </div>
            <hr />
            {
              (transactionData.type === 'purchase') &&
              <div className='transaction-info'>
                <div className='date'>
                  Purchased: <b>{format(new Date(transactionData.ts), "Pp")}</b>
                </div>
                <div className='total'>
                  Total Cost:
                  <ImageContainer src='/images/icons/coin.png'
                    className='coin-icon' />
                  <b>
                    {transactionData.cartTotal}
                  </b>
                </div>
                <div className='total'>
                  Item Count: <b>{transactionData.cartQuantity}</b>
                </div>
              </div>
            }
            <div className='g-space-1'></div>
            <div className='item-list'>
              {
                (transactionData.data && Object.values(transactionData.data).length > 0) &&
                Object.values(transactionData.data).map((d, i) => (
                  <div key={d.id + i}>
                    <TransactionItemCard
                      elementData={d}
                      transType={transactionData.type}
                    />
                  </div>
                ))
              }
            </div>
          </div>
          :
          (transactionData && transactionData.activity === 'Bulk Distribution')
            ?
            <div className='transaction-data'>
              <div className='header'>
                <div className='title'>
                  <ImageContainer src={transactionData.icon} />
                  <div className='title-info'>
                    <h3>{transactionData.title}</h3>
                    <h4>Bulk Distribution Details</h4>
                    <div className="meta">
                      {format(new Date(transactionData.ts), "Pp")}
                    </div>
                  </div>

                </div>
              </div>
              <hr />
              {
                (transLogs) &&
                <div className='logs-table'>
                  {
                    Object.values(transLogs)
                      .sort((a, b) => a.playerName < b.playerName ? -1 : 1)
                      .map((playerLogs, i) => {
                        return (
                          <div
                            key={playerLogs.playerId}
                            className='player-logs'>
                            <h4>{playerLogs.playerName}</h4>
                            <table className='g-table'>
                              <tbody>
                                {
                                  playerLogs.logs
                                    .sort((a, b) => a.message < b.message ? -1 : 1)
                                    .map((log, j) => {
                                      return (
                                        <tr key={j}>
                                          <td className={
                                            log.status === 'error' 
                                            ? 'red' 
                                            : ''
                                            }>
                                            {properCase(log.status)}: {log.message}
                                          </td>
                                        </tr>
                                      )
                                    })
                                }
                              </tbody>
                            </table>
                          </div>
                        )
                      })
                  }
                </div>
              }
            </div>
            :
            null

      }
      {/* <div className='g-space-2'></div>
      <div className='meta'>{transactionData && transactionData.path}</div> */}
      <ModalAlert
        show={!!alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage}
        onApprove={approveRef.current} />
    </div>
  )
}

export default TransactionView